import axios from 'axios'
import client from './client'

export default class FileSystemService {
  constructor (module, section, siteId, itemId) {
    this.module = module
    this.section = section
    this.siteId = siteId
    this.itemId = itemId
    if (this.siteId == null || this.siteId === undefined) {
      this.siteId = '-1'
    }
    if (this.itemId == null || this.itemId === undefined) {
      this.itemId = '-1'
    }
  }

  getAssignedFiles () {
    const url = '/api/filesystem/' + this.module + '/' + this.section + '/' + this.siteId + '/' + this.itemId
    return client.get(url, {})
  }

  uploadFile (file) {
    const url = '/api/filesystem/' + this.module + '/' + this.section + '/' + this.siteId + '/' + this.itemId

    var formData = new FormData()
    formData.append('file', file)
    return axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  removeFile (fileId) {
    const url = '/api/filesystem/' + fileId
    return client.delete(url, {})
  }
}
